<template>
<div class="chapter">
<div class="inner_page">
<p class="normal_001">For Colonel Edward St. George, who must be Bolan’s oldest living friend. Here’s to you, St. George, and to a most vigorous and active 94th year of life. <i>Kilauea</i>!</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?5700d930